module.exports = __webpack_public_path__ + "static/about-content-image-4@2x-655d172f31d427f263c4e00f3f57c24d.jpg";